const general = [
  { id: 1, href: "#user-roles", icon: "fa-user-shield", label: "User Roles", businessTypes: ["GENERAL"] },
  { id: 2, href: "#users", icon: "fa-user", label: "System Users", businessTypes: ["GENERAL"] },
  { id: 3, href: "#permissions", icon: "fa-shield-alt", label: "Permissions", businessTypes: ["GENERAL"] },
  { id: 4, href: "#company-profile", icon: "fa-briefcase", label: "Company Profile", businessTypes: ["GENERAL"], active: true },
  { id: 5, href: "#special-accounts", icon: "fa-university", label: "Special Accounts", businessTypes: ["GENERAL"] },
  { id: 6, href: "#preferences", icon: "fa-wrench", label: "Preferences", businessTypes: ["GENERAL"] },
  { id: 8, href: "#payment-gateway", icon: "fab fa-amazon-pay", label: "Payment Gateways", businessTypes: ["GENERAL"] },
  { id: 9, href: "#sign", icon: "fa-signature", label: "Signatories", businessTypes: ["GENERAL"] },
  { id: 11, href: "#keys", icon: "fa fa-key", label: "API Keys", businessTypes: ["GENERAL"] },
];

const school = [
  { id: 7, href: "#school-fees", icon: "fa-handshake", label: "School Fees", businessTypes: ["SCHOOL"] },
];

const gym = [
  { id: 10, href: "#gym", icon: "fa-dumbbell", label: "Gym", businessTypes: ["GYM"] },
];

// ✅ keyed object so you can do navItems['SCHOOL']
const navItems = {
  SCHOOL:  [...general, ...school],
  GYM:     [...general, ...gym],
  GENERAL: [...general],
};

export default navItems;
